import { useNavigate, useParams } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { getMetalDetails, updateMetal } from "../../helpers/http_metals_requests";
import { useQuery, useQueryClient } from "@tanstack/react-query";

const priceKindOptions = [
    { value: 1, label: "Usa cotação de ouro 18K" },
    { value: 2, label: "Usa cotação de ouro 10K" },
    { value: 3, label: "Usa cotação de prata" },
];

export default function MetalUpdate() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { id } = useParams();

    const { data, isFetching } = useQuery({
        queryKey: ["getMetalDetails", id],
        queryFn: () => getMetalDetails(id),
        staleTime: 1000 * 5,
    });

    const { data: metalData } = data?.data ?? {};

    const formFieldList = [
        {
            title: "Metal - Editar",
            fields: [
                { name: "name", label: "Nome", type: "text", required: true },
                { name: "color", label: "Cor", type: "text" },
                { name: "price_kind", label: "Cotação", type: "select", required: true, options: priceKindOptions },
                { name: "position", label: "Ordem", type: "number", required: true },
                { name: "is_active", label: "Ativo", type: "switch" },
            ],
        },
    ];

    const handleSubmit = (formData) => {
        updateMetal(
            {
                id: Number(id),
                name: formData.name,
                color: formData.color || "#C8A459",
                price_kind: Number(formData.price_kind) || 1,
                position: Number(formData.position) || 0,
                is_active: Boolean(formData.is_active),
            },
            () => {
                queryClient.invalidateQueries({ queryKey: ["getMetals"] });
                navigate("/configuracao-metais");
            }
        );
    };

    return (
        <DynamicFormPage
            isLoading={isFetching}
            initialData={metalData}
            title="Metal - Editar"
            formFieldList={formFieldList}
            onCancel={() => navigate(-1)}
            onSubmit={handleSubmit}
        />
    );
}
